import { useState, useEffect, useRef } from "react";
import "./AssistantChat.css";

export default function AssistantChat(){

const [open,setOpen] = useState(false)
const [typing,setTyping] = useState(false)

const [messages,setMessages] = useState([
{from:"bot",text:"👋 Hi! I'm Almond AI. How can I help you today?"}
])

const chatRef = useRef()

useEffect(()=>{
if(chatRef.current){
chatRef.current.scrollTop = chatRef.current.scrollHeight
}
},[messages,typing])

const questions = [
"What services do you offer?",
"Do you work with Salesforce?",
"Can you build a website?",
"Do you develop Shopify stores?",
"Pricing?",
"Start a project"
]

const answers = {

"What services do you offer?":
"We build high-performance digital systems — Salesforce, React apps, Shopify stores, automation & scalable APIs.",

"Do you work with Salesforce?":
"Yes. We specialize in Apex, LWC, Flows & enterprise-grade Salesforce automation.",

"Can you build a website?":
"Yes — fast, modern, SEO-optimized React websites designed for conversion.",

"Do you develop Shopify stores?":
"Absolutely. Premium Shopify stores with high-converting UX & custom features.",

"Pricing?":
"Websites ₹20k–₹80k. Shopify ₹30k–₹1.2L. Custom systems vary based on scale.",

"Start a project":
"Email softwarealmond@gmail.com or use our contact page to get started."
}

function handleQuestion(q){

setMessages(prev=>[...prev,{from:"user",text:q}])
setTyping(true)

setTimeout(()=>{

setTyping(false)

setMessages(prev=>[
...prev,
{from:"bot",text:answers[q]}
])

},1200)

}

return(
<>

<div className="chat-bubble" onClick={()=>setOpen(!open)}>
<div className="pulse"></div>
 <div className="emoji">💬</div>
</div>

{open && (

<div className="chat-window">

<div className="chat-header">
<div className="ai-avatar"></div>
<div>
<div className="title"></div>
<div className="status">Online</div>
</div>
</div>

<div className="chat-body" ref={chatRef}>

{messages.map((m,i)=>(
<div key={i} className={`msg ${m.from}`}>
{m.text}
</div>
))}

{typing && (
<div className="typing">
<span></span><span></span><span></span>
</div>
)}

</div>

<div className="chat-questions">
{questions.map((q,i)=>(
<button key={i} onClick={()=>handleQuestion(q)}>
{q}
</button>
))}
</div>

</div>

)}

</>
)
}